module.exports = __webpack_public_path__ + "static/media/18.1bd0742a.jpg";